import { render, staticRenderFns } from "./VerAlertaModal.vue?vue&type=template&id=13b4d49c&"
import script from "./VerAlertaModal.vue?vue&type=script&lang=ts&"
export * from "./VerAlertaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('13b4d49c', component.options)
    } else {
      api.reload('13b4d49c', component.options)
    }
    module.hot.accept("./VerAlertaModal.vue?vue&type=template&id=13b4d49c&", function () {
      api.rerender('13b4d49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Alertas/VerAlertaModal.vue"
export default component.exports